import { useCallback } from 'react';
import {
	type Attributes,
	fireUIAnalytics,
	useAnalyticsEvents,
} from '@atlassian/jira-product-analytics-bridge';

type SendAnalyticsType = {
	actionSubjectId: string;
	attributes?: Attributes;
};

const useSendAnalytics = (): ((arg1: SendAnalyticsType) => void) => {
	const { createAnalyticsEvent } = useAnalyticsEvents();

	const sendAnalytics = useCallback(
		({ actionSubjectId, attributes = {} }: SendAnalyticsType) => {
			const analyticsEvent = createAnalyticsEvent({
				eventType: 'UI',
				action: 'clicked',
				actionSubject: 'button',
				actionSubjectId,
			});

			fireUIAnalytics(analyticsEvent, actionSubjectId, attributes);
		},
		[createAnalyticsEvent],
	);

	return sendAnalytics;
};

export { useSendAnalytics };
